import type { FaireProductEntity } from "../../entity_types/product";

export const p_96ywvevwpy: FaireProductEntity = {
  token: "p_96ywvevwpy",
  type: "product",
  name: "Curious Elixir No. 7 Booze-Free Cocktails",
  brandToken: "b_3opsa00um8",
  brandName: "Curious Elixirs",
  imageUrl:
    "https://cdn.faire.com/fastly/9b017ea1e2479987859df7094578b48d3cbfe1312a3d4c7f43e58b392fcbd7f7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4a9ca9a2ab38b756a21cfc1dfc2275420915843ff32c76a5c0b0266837b7998e.png",
    "https://cdn.faire.com/fastly/fc839f27574f28d4a779413c9ed4e53f6dab0e90606d895405e28788f532ea2c.jpeg",
    "https://cdn.faire.com/fastly/62d67c552b884f624a8e44f210d0b9702ae59195096d229504d36ce195daaf29.jpeg",
    "https://cdn.faire.com/fastly/0ea467f3a32b8f717c3fe9aa6bec420299a81ab4639c2af223b81ff113ab840f.jpeg",
  ],
  priceDollars: 89.38,
  description:
    "Our dry and bitter booze-free champagne cocktail with elderflower and lavender to help you unwind. \n\nHere’s a toast to the good times—Curious No. 7 is our booze-free champagne cocktail riff on the French 77, and the perfect companion for celebrations large and small--from weddings to Wednesdays. \n\nWe start with California Chardonnay grapes, and infuse them with elderflower, juniper, lavender, a touch of jasmine green tea, juniper, and gentian root.  We're now bottling and canning so you may receive bottles or cans in your shipment.\n\nWith zero alcohol, Curious No. 7 was made for special moments or as an uplifting self-care ritual. Serve chilled and up in a coupe with a twist of lemon, add an optional drop of honey before pouring for a touch of sweetness. Cheers!",
  tags: [],
  msrpDollars: 178.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:48.967Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
